// BSL-TKL §4 — Teklif turları. Ekran başına en çok 3 balon, metin ≤ 140 karakter.
// Bir `data-tur` elemanı silinir/taşınırsa bu dosya aynı commit'te düzeltilir (çatı §12).
// Teklif Oluştur stepper'ı: her adım kendi turudur; Başlarken turu açıldıysa sayfa adıma geçince
// sıradakini ister (bsl.sonTur), atlanan adımın balonu çıkmaz.
export default {
  teklifKural: {
    yol: "/teklif/parametreler",
    adimlar: [
      { hedef: '[data-tur="tts-gecerlilik"]', metin: "Teklif kaç gün geçerli olsun; her teklifte değiştirilebilir." },
      { hedef: '[data-tur="tts-esikler"]', metin: "İskonto, marj ya da tutar eşiği aşılırsa teklif onaya düşer. Boş = kapalı.", kavram: "onayEsigi" },
      { hedef: '[data-tur="tts-onaycilar"]', metin: "Onaycıları sırasıyla seçin. Onaycı yoksa eşik aşılsa da onay istenmez." },
    ],
  },
  teklifOlustur: {
    yol: "/teklif/teklifolustur",
    adimlar: [
      { hedef: '[data-tur="teklif-musteri"]', metin: "Müşteriyi seçin ya da buradan yenisini ekleyin. Proje adı ve açıklama da zorunlu; hazır bir şablonla başlayabilirsiniz." },
    ],
  },
  teklifOlusturKalem: {
    yol: "/teklif/teklifolustur",
    adimlar: [
      { hedef: '[data-tur="teklif-kalem"]', metin: "Kategorileri işaretleyip ürünleri ekleyin. Fiyat ürün maliyetinin altına inemez.", kavram: "maliyetAlti" },
    ],
  },
  teklifOlusturOzet: {
    yol: "/teklif/teklifolustur",
    adimlar: [
      { hedef: '[data-tur="teklif-ozet"]', metin: "Toplamları kontrol edip kaydedin; teklif Taslak olarak açılır.", kavram: "teklifDurumu" },
    ],
  },
  teklifDetay: {
    yol: "/teklif/teklifdetay",
    adimlar: [
      { hedef: '[data-tur="teklif-gonder"]', metin: "Teklifi müşteriye e-postayla gönderin; gönderilmiş teklifi «Tekrar Gönder» yeniden yollar. Müşteri bağlantıdan kabul ya da ret eder." },
      { hedef: '[data-tur="teklif-revize"]', metin: "Gönderilmiş teklif değiştirilemez; «Revize Et» yeni sürüm açar." },
      { hedef: '[data-tur="teklif-siparis"]', metin: "Kazanılan teklifi buradan siparişe dönüştürün." },
    ],
  },
  teklifListe: {
    yol: "/teklif/tekliflistesi",
    adimlar: [
      { hedef: '[data-tur="teklif-yeni"]', metin: "Yeni teklif buradan başlar." },
      { hedef: '[data-tur="teklif-durum"]', metin: "Teklifin nerede olduğunu durum söyler.", kavram: "teklifDurumu" },
      { hedef: '[data-tur="teklif-gonderim-merkezi"]', metin: "Müşterinin teklifi görüntüleyip görüntülemediğini Gönderim Merkezi'nden izleyin.", kavram: "gonderimMerkezi" },
    ],
  },
  // ? menüsü: Talep Listesi
  talepListe: {
    yol: "/talep-teklif-siparis/taleplistesi",
    adimlar: [
      { hedef: '[data-tur="talep-paylas"]', metin: "Talep formunun bağlantısını paylaşın; gelen talepler burada teklife dönüştürülür." },
    ],
  },
  // TKL-TALEP: Talep Listesi paylaşım penceresi açık gelir (bsl.pencereIstegi = "talepPaylas").
  talepPaylas: {
    yol: "/talep-teklif-siparis/taleplistesi",
    pencere: true,
    adimlar: [
      { hedef: '[data-tur="paylas-kopyala"]', metin: "Bağlantıyı kopyalayın; her şubenin kendi bağlantısı var." },
      { hedef: '[data-tur="paylas-qr"]', metin: "QR kodunu yazdırıp girişe asabilir, gömme koduyla sitenize ekleyebilirsiniz." },
      { hedef: '[data-tur="paylas-dene"]', metin: "Formu açıp kendinize deneme talebi gönderin; sonra listeden İptal edin." },
    ],
  },
};
